import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import DrawIcon from "../../../assets/images/draw_icon.svg";
import EraserIcon from "../../../assets/images/eraser_icon.svg";
import CaptureIcon from "../../../assets/images/capture_icon.svg";
import MarkerIcon from "../../../assets/images/pen_icon.png"

export default class PentoolAlertPopup extends Component {
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.togglePopup) {
      this.props.togglePopup();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  toggle = () => {
    this.props.togglePopup()
  }

  render() {
    const { isOpen, isNotShowPentoolInstruction, changeNotShowModal } = this.props
    return (
      <Modal
        isOpen={isOpen}
        toggle={() => this.toggle()}
        className="modal-dialog-centered w-fit-content m-auto modal-style"
        modalClassName="modal-second"
        contentClassName="akaire_alert_popup"
      >
        <div className='swal2-html-container'>
          <div className="pentool-instruction-modal">
            <div className='pentool-instruction-modal-title modal-header'>ペンツールに切り替わりました。</div>
            <div className="pentool-instruction-box">
              <div className="pentool-instruction-content">
                <div className="pentool-instruction-title">
                  <span className="pentool-instruction-title-text">【ペンツールの操作方法について】</span>
                </div>
                <div className="pentool-instruction-item">
                  <div className='pentool-instruction-item-number'>
                    1.
                  </div>
                  <div className='pentool-instruction-item-content-wrapper'>
                    <div className='pentool-instruction-item-content'>
                      <img src={DrawIcon} alt="draw icon" className="btn-draw"/>
                      から、ペンの太さやカラーを変更できます。
                    </div>

                    <div className='pentool-instruction-item-content'>
                      <img src={EraserIcon} alt="eraser icon" className="btn-eraser"/>
                      クリックすると、入力したペンを消去できます。もう一度、
                    </div>

                    <div className='pentool-instruction-item-content'>
                      <img src={MarkerIcon} alt="capture icon" className="btn-marker"/>
                      をクリックすると、ペンツールが解除されます
                    </div>
                  </div>
                </div>
                <div className="pentool-instruction-item">
                  <div className='pentool-instruction-item-number'>
                    2.
                  </div>
                  <div className='pentool-instruction-item-content-wrapper'>
                    <div className='pentool-instruction-item-content'>
                      ペン入力が完了したら、<img src={CaptureIcon} alt="capture icon" className="btn-capture"/>をクリックしてコメントBOXを開きます。
                    </div>
                  </div>
                </div>
                <div className="pentool-instruction-item">
                  <div className='pentool-instruction-item-number'>
                    3.
                  </div>
                  <div className='pentool-instruction-item-content-wrapper'>
                    <div className='pentool-instruction-item-content'>
                      コメントBOXにコメントを入力して「保存」をクリックすると、ペンツールのコメントおよびペン入力画面のキャプチャが保存されます。
                    </div>
                  </div>
                </div>
                <div className="pentool-instruction-item">
                  <div className='pentool-instruction-item-number'>
                    4.
                  </div>
                  <div className='pentool-instruction-item-content-wrapper'>
                    <div className='pentool-instruction-item-content'>
                      保存すると、「ペンツールの作業を終了しますか？」というポップアップが表示され、「OK」をクリックすると作業を終了します。
                    </div>
                  </div>
                </div>
                <div className="pentool-instruction-notes">
                  <div className="pentool-instruction-notes-text">
                    ※ペンツールの作業中にメディア画面以外をクリックすると、
                  </div>
                  <div className="pentool-instruction-notes-text">
                    「このままペンツールを終了しますか？」というポップアップが表示されます。
                  </div>
                  <div className="pentool-instruction-notes-text-wrapper">
                    <div className="pentool-instruction-notes-text">
                      「OK」をクリックすると、入力した履歴が保存されないままペンツールが終了しますのでご注意ください。
                    </div>
                    <div className="pentool-instruction-checkbox-wrapper">
                      <label className="pentool-instruction-checkbox-label">
                        <input
                          type="checkbox"
                          id="hidePentoolInstructionCheckbox"
                          className="pentool-instruction-checkbox"
                          checked={isNotShowPentoolInstruction}
                          onClick={(event) => changeNotShowModal(event)}
                        />
                        今後、表示させない
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}
